function Home() {
  return <div style={{ paddingTop: ' 25px' }}>Home backoffice</div>;
}

export default Home;
